import * as React from "react";
const SvgFiBrandsAccusoft = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 25 24"
    {...props}
  >
    <g
      fill="#151A2D"
      fillRule="evenodd"
      clipPath="url(#fi-brands-accusoft_svg__a)"
      clipRule="evenodd"
    >
      <path d="M18.831 16.345c-.217-.26-9.072-11.13-9.38-11.496-.29-.366-.218-.47-.163-.523.109-.122.271-.105.907-.105.381 0 4.155-.017 4.554-.017.817 0 .944.07 1.034.087.091.035.309.21.472.383.09.105 8.02 9.214 8.092 9.301.09.105.218.28.327.435.09.157.11.366-.036.453-.091.052-4.482 1.794-4.609 1.83-.127.051-.362.138-.545.104-.09.001-.362-.12-.653-.452" />
      <path d="m23.313 16.136.327.052s1.052.192 1.161.226c.108.018.199.105.199.14 0 .087-.054.122-.145.174-.073.052-4.826 2.856-4.916 2.91-.091.051-.2.104-.454.138-.471.087-1.36-.157-1.65-.209-.273-.052-11.94-2.543-12.03-2.578-.11-.035-.181-.035-.181-.139-.018-.157.235-.209.435-.279s5.68-1.968 5.879-2.055c.2-.087.435-.105.562-.105s.889.105 1.233.157 1.324.192 1.324.192l2.231 2.77c.382.434.636.61.962.626.163.017.345-.035.472-.087.091-.034 4.59-1.933 4.59-1.933" />
      <path d="M10.576 9.343s1.978 2.456 2.014 2.473v.035c-.073.052-3.502 3.1-3.52 3.118L5.46 16.24s-.11.035-.164.07-.127.105-.11.261c0 .052.018.853.037 1.045-.018.017-4.17 1.28-4.5 1.376-.218.07-.635.21-.69.174-.09-.07.018-.174.073-.244S9.27 10.248 9.614 9.9c.49-.505.962-.557.962-.557" />
    </g>
    <defs>
      <clipPath id="fi-brands-accusoft_svg__a">
        <path fill="#fff" d="M0 0h25v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiBrandsAccusoft;
